import { render, staticRenderFns } from "./CopasIcon.vue?vue&type=template&id=0b268991"
import script from "./CopasIcon.vue?vue&type=script&lang=js"
export * from "./CopasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports